module.exports = __webpack_public_path__ + "static/media/karta-techniczna-q-led_en.42b02a69.pdf";